import { EntitlementGroupModelDto, EntitlementModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../shared';

export class EntitlementGroup extends DomainEntity<EntitlementGroupModelDto> {
    constructor(
        dto: EntitlementGroupModelDto = {
            id: 0,
            sequence: 0,
        }
    ) {
        super(dto);
    }

    public createDefault(): this {
        return new EntitlementGroup() as this;
    }

    public get category(): string {
        return this.dto.category ?? '';
    }

    public get entitlements(): Entitlement[] {
        return this.dto.entitlements?.map(entitlement => new Entitlement(entitlement)) ?? [];
    }

    public get sequence(): number {
        return this.dto.sequence ?? 0;
    }
}

export class Entitlement extends DomainEntity<EntitlementModelDto> {
    constructor(
        dto: EntitlementModelDto = {
            claimId: 0,
            sequence: 0,
        }
    ) {
        super(dto);
    }

    public createDefault(): this {
        return new Entitlement() as this;
    }

    public get claimId(): number {
        return this.dto.claimId ?? 0;
    }

    public get name(): string {
        return this.dto.name ?? '';
    }

    public get sequence(): number {
        return this.dto.sequence ?? 0;
    }

    public get hasPrerequisites(): boolean {
        return (this.dto.prerequisiteClaims?.length ?? 0) > 0;
    }

    public get prerequisiteClaims(): number[] {
        return this.dto.prerequisiteClaims ?? [];
    }
}
